import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { intent } from "@/lib/ui-theme";

interface WarmingBannerProps {
  isVisible: boolean;
}

export function WarmingBanner({ isVisible }: WarmingBannerProps) {
  if (!isVisible) return null;

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-50 w-full border-b px-4 py-3",
        intent.warning.surface,
      )}
    >
      <div className="container mx-auto flex items-center justify-center gap-3">
        <Loader2 className="h-5 w-5 animate-spin text-amber-600 dark:text-amber-300" />
        <p className="text-sm">
          <strong>Loading data...</strong> The service is warming up. This may take a few minutes on first startup.
        </p>
      </div>
    </div>
  );
}
